import { render, staticRenderFns } from "./Home-web.vue?vue&type=template&id=40afce98&scoped=true"
import script from "./Home-web.vue?vue&type=script&lang=js"
export * from "./Home-web.vue?vue&type=script&lang=js"
import style0 from "./Home-web.vue?vue&type=style&index=0&id=40afce98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40afce98",
  null
  
)

export default component.exports